import { MutationConfig } from '@/lib/react-query';
import { ModelID } from '@/types';
import { post } from '@/utils/api';
import { useMutation } from '@tanstack/react-query';
import { featurePath } from '.';

type QueryFnType = typeof postCreateSetupIntent;

type UseCreateSetupIntentOptions = {
  config?: MutationConfig<QueryFnType>;
};

export type CreateSetupIntentInput = {
  customer_id: ModelID;
  franchise_id: ModelID;
};

export type CreateSetupIntentResponse = {
  client_secret: string;
  setup_intent_id: string;
  stripe_account_id: string;
};

const postCreateSetupIntent = (data: CreateSetupIntentInput) =>
  post<CreateSetupIntentResponse>(`${featurePath}/create-setup-intent`, data);

export const useCreateSetupIntent = ({ config = {} }: UseCreateSetupIntentOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: postCreateSetupIntent,
  });
};
